import Vue from 'vue';
import { cpf } from 'cpf-cnpj-validator'; 
import { cnpj } from 'cpf-cnpj-validator'; 

Vue.prototype.$cpf = cpf;
Vue.prototype.$cnpj = cnpj;